import { render, staticRenderFns } from "./uploadCover.vue?vue&type=template&id=e972ed7a&scoped=true"
import script from "./uploadCover.vue?vue&type=script&lang=js"
export * from "./uploadCover.vue?vue&type=script&lang=js"
import style0 from "./uploadCover.vue?vue&type=style&index=0&id=e972ed7a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e972ed7a",
  null
  
)

export default component.exports